import { API_URL } from '../../../../utils/config';

/* eslint-disable import/prefer-default-export */
export const GET_CUSTOMER_DETAILS_URL = `https://api.tizeti.com/api/v1/account/get_account_daily`;
export const GET_UPDATE_CUSTOMER_DETAILS_URL = `https://api.tizeti.com/api/v1/installationUploads/fixupload`;
export const KYC_UPLOAD_URL = `https://api.tizeti.com/api/v1/installationUploads`;
